import { Backbone } from "extensions/backbone";

import { store } from "common/store";

import { ParameterizedCollection } from "common/collections/parameterizedCollection";
import { getByType } from "./widgets/_all";

export const WidgetsCollection = ParameterizedCollection.extend({
    url: "/merchant/:merchant_ref/user/dashboard/",
    
    // Polymorphic ui models based on widget's type
    model: function model(attrs, options) {
        const Model = getByType(attrs.widgetType, "Model");
        
        if (Model) {
            return new Model(attrs, options);
        }
        
        return ParameterizedCollection.prototype.apply(this, arguments);
    },
    
    parse(data) {
        const subtypeAccess = {
            authorizations: store.getState().permissions.user_permissions.data_access_authorizations,
            fees: store.getState().permissions.user_permissions.data_access_fees,
            chargebacks: store.getState().permissions.user_permissions.data_access_chargebacks,
            sales: store.getState().permissions.user_permissions.data_access_sales_refunds,
            refunds: store.getState().permissions.user_permissions.data_access_sales_refunds
        };
        
        return data.map((widget) => {
            // Normalize widget
            // Normalize pivot to array
            const hasPivots = typeof widget.options.pivot !== "undefined";
            if (hasPivots) {
                widget.options.pivot = Array.isArray(widget.options.pivot) ? widget.options.pivot : [widget.options.pivot];
            }
    
            // Deprecate `codes` pivot in authorizations and use `response_code` instead
            if (widget.widgetSubtype === "authorizations" && hasPivots) {
                widget.options.pivot = widget.options.pivot.map((p) => {
                    if (p === "codes") {
                        return "response_code";
                    }
                    return p;
                });
            }
    
            // Deprecate old `chargeback_rate` widget subtype and use chargebacks instead
            if (widget.widgetSubtype === "chargeback_rate") {
                widget.widgetSubtype = "chargebacks";
            }
    
            // Deprecate old `refund_rate` widget subtype
            if (widget.widgetSubtype === "refund_rate") {
                widget.widgetSubtype = "refunds";
            }
    
            // Deprecate `codes` pivot in chargebacks widgets and use `reason_code` instead
            if (widget.widgetSubtype === "chargebacks" && hasPivots) {
                widget.options.pivot = widget.options.pivot.map((p) => {
                    if (p === "codes") {
                        return "reason_code";
                    }
                    return p;
                });
            }
            
            return widget;
        }).filter((widget) => {
            // Check permissions
            if (Object.prototype.hasOwnProperty.call(subtypeAccess, widget.widgetSubtype)) {
                return subtypeAccess[widget.widgetSubtype];
            } if (widget.widgetType === "custom.chargebackRateByNetwork") {
                return subtypeAccess.chargebacks;
            }
            throw new Error(`Unknown widget type ${widget.widgetSubtype}`);
        });
    },
    
    save() {
        Backbone.sync("patch", this, {
            success() {},
            error() {}
        });
    },
    
    toJSON() {
        return this.map((model) => model.getModelData());
    }
});
